import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import Avatar from '@/components/ui/Avatar'
import { getMyTrainers } from '@/services/clients'

export default function MorePage() {
  const { user, logout } = useAuthStore()
  const [hasActiveTrainer, setHasActiveTrainer] = useState(false)
  const [trainerCheckDone, setTrainerCheckDone] = useState(false)

  useEffect(() => {
    if (user?.role === 'client') {
      getMyTrainers()
        .then((data) => {
          const active = data.trainers.some(
            (t) => t.status === 'approved' || t.status === 'trial' || t.status === 'frozen'
          )
          setHasActiveTrainer(active)
        })
        .catch(() => {})
        .finally(() => setTrainerCheckDone(true))
    }
  }, [user?.role])

  const handleLogout = () => {
    logout()
  }

  return (
    <div className="p-4">
      {/* Профиль пользователя */}
      <div className="bg-tg-secondary rounded-xl p-4 mb-6">
        <div className="flex items-center gap-4">
          <Avatar
            src={user?.photo_url}
            name={`${user?.first_name} ${user?.last_name || ''}`}
            size="xl"
          />
          <div>
            <div className="font-semibold text-tg-text text-lg">
              {user?.first_name} {user?.last_name || ''}
            </div>
            {user?.username && (
              <div className="text-sm text-tg-hint">@{user.username}</div>
            )}
            <div className="text-xs text-tg-hint mt-1 capitalize">
              {user?.role === 'client' ? 'Клиент' : user?.role === 'trainer' ? 'Тренер' : 'Админ'}
            </div>
          </div>
        </div>
      </div>

      {/* Меню */}
      <div className="space-y-2 mb-6">
        {user?.role === 'client' && trainerCheckDone && !hasActiveTrainer && (
          <MenuItem
            icon="🔗"
            label="Присоединиться к тренеру"
            to="/join"
          />
        )}
        {user?.role !== 'client' && (
          <MenuItem
            icon="⚙️"
            label="Настройки расписания"
            to="/schedule/settings"
          />
        )}
      </div>

      {/* Выход */}
      <div className="mt-auto">
        <button
          onClick={handleLogout}
          className="w-full bg-red-500/10 text-red-500 rounded-xl p-4 font-medium flex items-center justify-center gap-2 active:bg-red-500/20 transition-colors"
        >
          <span>Выйти из аккаунта</span>
        </button>
      </div>
    </div>
  )
}

function MenuItem({
  icon,
  label,
  to,
}: {
  icon: string
  label: string
  to: string
}) {
  return (
    <Link
      to={to}
      className="flex items-center gap-3 bg-tg-secondary rounded-xl p-4 active:opacity-80 transition-opacity"
    >
      <span className="text-xl">{icon}</span>
      <span className="text-tg-text font-medium">{label}</span>
      <span className="ml-auto text-tg-hint">→</span>
    </Link>
  )
}
